import React from 'react';
import Utility from "./Utility";

const URL_ACCOUNTS_AUTHENTICATION = `/accounts/authentication`;
const URL_SELECT_ITEM_POMP_SPEC = `/selectItem/pompSpec`;
const URL_BUSINESS_PARTNERS = `/businessPartners/search`;
const URL_SELECT_MAIN_CLEANING_JIG = `/selectItem/mainCleaningJig`;
const URL_SELECT_EXPENDABLES = `/selectItem/expendables`;
const URL_TRANSACTION_ADD = `/transaction`;
const URL_TRANSACTION_EDIT = `/transaction/`;
const URL_TRANSACTION_GET = `/transaction/`;
const URL_TRANSACTION_SEARCH = `/transaction/search`;
const URL_CALENDARS_GET = `/calendars`;
const URL_CALENDARS_PUT = `/calendars`;
const URL_SCENE_GET_LIST = `/scene/getList`;
const URL_SCENE_UPLOAD = `/scene/upload`;
const URL_SCENE_DELETE = `/scene/delete`;
const URL_SCENE_GET_NEW_SCENE_DETAIL_NUMBER = `/scene/getNewSceneDetailNumber`;
const URL_HEAT_EXCHANGER_GET = `/heatExchanger/get`;
const URL_HEAT_EXCHANGER_UPDATE = '/heatExchanger/update';
const URL_HEAT_EXCHANGER_UPLOAD = '/heatExchanger/upload';
const URL_MFA_REGISTER = '/accounts/mfa/register';
const URL_MFA = '/accounts/mfa';

const FETCH_FAIL_MESSAGE = '通信に失敗しました。ネットワーク接続を確認してください。\n確認の上で改善しない場合はシステム管理者に連絡して下さい。';
const UPDATE_HEAT_EXCHANGER_FAIL_MESSAGE = '通信に失敗しました。ネットワーク接続を確認して、再度操作を行ってください。';

class ApiFetcher extends React.Component {
    static fetchPost(url, token, bodyJson, callback) {
        return fetch(process.env.REACT_APP_API_URL + url, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'content-type': 'application/json; charset=utf-8',
                'X-Acl-Token': token
            },
            body: bodyJson,
        })
            .then((response) => {
                return response.json();
            })
            .then((responseJson) => {
                callback(responseJson);
            })
            .catch(() => {
                alert(FETCH_FAIL_MESSAGE);
            });
    }

    static fetchPut(url, token, bodyJson, callback) {
        let requestUrl = process.env.REACT_APP_API_URL + url;
        let headers = {
            method: 'PUT',
            mode: 'cors',
            headers: {
                'content-type': 'application/json; charset=utf-8',
                'X-Acl-Token': token
            },
            body: bodyJson,
        };

        return fetch(requestUrl, headers)
            .then((response) => {
                return response.json();
            })
            .then((responseJson) => {
                callback(responseJson);
            })
            .catch(() => {
                alert(FETCH_FAIL_MESSAGE);
            });
    }

    static fetchGet(url, token, callback) {
        return fetch(process.env.REACT_APP_API_URL + url, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'content-type': 'application/json; charset=utf-8',
                'X-Acl-Token': token
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((responseJson) => {
                if (callback !== null) {
                    callback(responseJson);
                }
            })
            .catch(() => {
                alert(FETCH_FAIL_MESSAGE);
            });
    }

    static fetchDelete(url, token, callback) {
        return fetch(process.env.REACT_APP_API_URL + url, {
            method: 'DELETE',
            mode: 'cors',
            headers: {
                'content-type': 'application/json; charset=utf-8',
                'X-Acl-Token': token
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((responseJson) => {
                if (callback !== null) {
                    callback(responseJson);
                }
            })
            .catch(() => {
                alert(FETCH_FAIL_MESSAGE);
            });
    }

    static postAccountsAuthentication(mailAddress, password, callback) {
        let body = JSON.stringify({
            mailAddress: mailAddress,
            password: password
        });
        this.fetchPost(URL_ACCOUNTS_AUTHENTICATION, null, body, callback);
    }

    static getSelectItemPompSpec(token, callback) {
        this.fetchGet(URL_SELECT_ITEM_POMP_SPEC, token, callback);
    }

    static postBusinessPartners(token, pompSpecId, deliveryStart, deliveryEnd, callback) {
        let body = JSON.stringify({
            pompSpecId: pompSpecId,
            deliveryStart: Utility.formatDate(new Date(deliveryStart), 'yyyyMMdd'),
            deliveryEnd: Utility.formatDate(new Date(deliveryEnd), 'yyyyMMdd')
        });
        this.fetchPost(URL_BUSINESS_PARTNERS, token, body, callback);
    }

    static getSelectItemMainCleaningJig(token, callback) {
        this.fetchGet(URL_SELECT_MAIN_CLEANING_JIG, token, callback);
    }

    static getSelectItemExpendables(token, callback) {
        this.fetchGet(URL_SELECT_EXPENDABLES, token, callback);
    }

    static postAddRequestDispatch(token, businessPartnerUserId, kecUserId, expectedUseStartDate, expectedReturnDate, pompSpecId, dispatchNum, dispatchDestination, mainCleaningJig, expendables, note, callback) {
        let body = JSON.stringify({
            sellerAccountId: businessPartnerUserId,
            buyerAccountId: kecUserId,
            expectedUseStartDate: Utility.formatDate(new Date(expectedUseStartDate), 'yyyyMMdd'),
            expectedReturnDate: Utility.formatDate(new Date(expectedReturnDate), 'yyyyMMdd'),
            pompSpecId: pompSpecId,
            dispatchNum: parseInt(dispatchNum, 10),
            dispatchDestination: dispatchDestination,
            mainCleaningJig: mainCleaningJig,
            expendables: expendables,
            note: note
        });
        this.fetchPost(URL_TRANSACTION_ADD, token, body, callback);
    }

    static putEditRequestDispatch(token, id, progressStatus, cancelReason, callback) {
        let body = JSON.stringify({
            progressStatus: parseInt(progressStatus),
            cancelReason: cancelReason
        });
        this.fetchPut(URL_TRANSACTION_EDIT + id, token, body, callback);
    }

    static getRequestDispatch(token, id, callback) {
        this.fetchGet(URL_TRANSACTION_GET + id, token, callback);
    }

    static searchRequestDispatch(token, sellerAccountId, buyerAccountId, progressStatus, businessPartnerName, dispatchDestination, deliveryPeriodSince, deliveryPeriodUntil, limit, offset, callback) {
        let bodyObject = {
            sellerAccountId: sellerAccountId,
            buyerAccountId: buyerAccountId,
            progressStatuses: [
                {
                    "progressStatus": progressStatus
                }
            ],
            businessPartnerName: businessPartnerName,
            dispatchDestination: dispatchDestination,
            deliveryPeriodSince: '',
            deliveryPeriodUntil: '',
            // limit: 100, // STEP2以降で対応.
            // offset: 0, // STEP2以降で対応.
            // orderby: 'createDate desc', // STEP2以降で対応.
        };
        if (sellerAccountId === "") {
            delete bodyObject.sellerAccountId;
        }
        if (buyerAccountId === "") {
            delete bodyObject.buyerAccountId;
        }
        if (parseInt(progressStatus, 10) === -1) { // 未指定 === -1.
            let progressStatuses = [];
            for (let i = 0; i < Utility.DISPATCH_PROGRESS_STATUSES.length; i++) {
                let progressStatusObject = {};
                progressStatusObject.progressStatus = Utility.DISPATCH_PROGRESS_STATUSES[i].value;
                progressStatuses.push(progressStatusObject);
            }
            bodyObject.progressStatuses = progressStatuses;
        } else if (parseInt(progressStatus, 10) === -2) { // キャンセル一覧　未指定 === -2
            let progressStatuses = [];
            for (let i = 0; i < Utility.CANCEL_PROGRESS_STATUSES.length; i++) {
                let progressStatusObject = {};
                progressStatusObject.progressStatus = Utility.CANCEL_PROGRESS_STATUSES[i].value;
                progressStatuses.push(progressStatusObject);
            } 
            bodyObject.progressStatuses = progressStatuses;
        }

        if (businessPartnerName === "") {
            delete bodyObject.businessPartnerName;
        }
        if (dispatchDestination === "") {
            delete bodyObject.dispatchDestination;
        }

        if (deliveryPeriodSince === "") {
            delete bodyObject.deliveryPeriodSince;
        } else {
            bodyObject.deliveryPeriodSince = Utility.formatDate(new Date(deliveryPeriodSince), 'yyyyMMdd');
        }

        if (deliveryPeriodUntil === "") {
            delete bodyObject.deliveryPeriodUntil;
        } else {
            bodyObject.deliveryPeriodUntil = Utility.formatDate(new Date(deliveryPeriodUntil), 'yyyyMMdd');
        }

        let body = JSON.stringify(bodyObject);
        this.fetchPost(URL_TRANSACTION_SEARCH, token, body, callback);
    }

    static getCalendarsForSetNonDispatchableNum(token, matchingId, sinceCalendarDate, untilCalendarDate, pompSpecId, callback) {
        let url = URL_CALENDARS_GET + '?matchingId=' + matchingId + '&sinceCalendarDate=' + Utility.formatDate(sinceCalendarDate, 'yyyyMMdd') + '&untilCalendarDate=' + Utility.formatDate(untilCalendarDate, 'yyyyMMdd') + '&pompSpecId=' + pompSpecId;
        this.fetchGet(url, token, callback);
    }

    static putCalendars(token, calendarDate, matchingId, pompSpecId, dispatchNum, callback) {
        let body = JSON.stringify({
            calendarDate: Utility.formatDate(calendarDate, 'yyyyMMdd'),
            matchingId: matchingId,
            pompSpecId: pompSpecId,
            dispatchNum: dispatchNum
        });
        this.fetchPut(URL_CALENDARS_PUT, token, body, callback);
    }

    static getSceneList(token, callback){
        this.fetchGet(URL_SCENE_GET_LIST, token, callback);
    }

    static postSceneUpload(token, jsonArray, callback){
        let body = JSON.stringify({
            sceneUploadRequestArray: jsonArray
        });
        this.fetchPost(URL_SCENE_UPLOAD, token, body, callback);
    }

    static deleteScene(token, csvId, callback){
        this.fetchDelete(URL_SCENE_DELETE + '?csvId=' + csvId, token, callback);
    }

    static getNewSceneDetailNumber(token, csvId, callback) {
        this.fetchGet(URL_SCENE_GET_NEW_SCENE_DETAIL_NUMBER + '?csvId=' + csvId, token, callback);
    }

    static getHeatExchanger(token, csvId, callback) {
        this.fetchGet(URL_HEAT_EXCHANGER_GET + '?csvId=' + csvId, token, callback);
    }

    static updateHeatExchanger(token, heatExchangerArray, callback) {
        let body = JSON.stringify({
            heatExchangerUpdateRequestArray: heatExchangerArray
        });

        // 熱交更新の失敗時は異なるメッセージを表示するためthis.fetchPostは使用しない.
        return fetch(process.env.REACT_APP_API_URL + URL_HEAT_EXCHANGER_UPDATE, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'content-type': 'application/json; charset=utf-8',
                'X-Acl-Token': token
            },
            body: body,
        })
            .then((response) => {
                return response.json();
            })
            .then((responseJson) => {
                callback(responseJson);
            })
            .catch(() => {
                alert(UPDATE_HEAT_EXCHANGER_FAIL_MESSAGE);
            });
    }

    static postHeatExchangerUpload(token, csvId, jsonArray, callback) {
        let body = JSON.stringify({
            csvId: csvId,
            heatExchangerUploadRequestArray: jsonArray
        });
        this.fetchPost(URL_HEAT_EXCHANGER_UPLOAD, token, body, callback);
    }

    static postMfa(json, callback){
        this.fetchPost(URL_MFA, null, json, callback);
    }

    static postMfaRegister(json, callback){
        this.fetchPost(URL_MFA_REGISTER, null, json, callback);
    }
}

export default ApiFetcher;